export default "__VITE_ASSET__BjBYf6LP__"